import React, { useRef } from "react";
import { RadarData, RadarOptions } from "./radarConfig";
import { Radar } from "react-chartjs-2";

const RadarChart = (props) => {

  const { dataChart } = props;
  const refChart = useRef();
  
  return <Radar ref={refChart} data={RadarData(dataChart)} options={RadarOptions(dataChart)}/>;
};
export { RadarChart };
